export default {
  viewType: 'poc-project-detail-overview',
  breadcrumb: {
    title: '',
    action: '',
    class: ''
  },
  params: {}
}
